import { render } from "./BigPictureBannerOrange.vue?vue&type=template&id=3ac57839&scoped=true"
import script from "./BigPictureBannerOrange.vue?vue&type=script&lang=js"
export * from "./BigPictureBannerOrange.vue?vue&type=script&lang=js"

import "./BigPictureBannerOrange.vue?vue&type=style&index=0&id=3ac57839&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac57839"]])

export default __exports__